import React from "react";

import { CommonTextField } from "./CommonTextField";
import { MenuItem } from "@material-ui/core";

import "./CommonSelect.scss";

export const CommonSelect = ({ options, placeholder, ...props }: any) => {
  //Options
  const optionClass =
    "common-select-option" + (props.disabled ? "--disabled" : "");

  return (
    <CommonTextField {...props} placeholder={placeholder} select autoComplete="new-password">
      {options.map((option: any) => {
        return (
          <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
            <div className={optionClass}>{option.label}</div>
          </MenuItem>
        );
      })}
    </CommonTextField>
  );
};
